/**
 * Given validator of type `Validator<Value, Props>` and props of type `Props`, returns a new
 * validator of type `Validator<Value>`
 */
export function withProps(validator, props) {
    return function (value) { return validator(value, props); };
}
//# sourceMappingURL=withProps.js.map